import React from 'react';
import { Button } from 'reactstrap';

import styles from './ActionCard.module.scss';

interface Props {
    onCancel: () => void;
    onSave?: () => void;
    onSaveAndFreeze?: () => void;
    isSaveDisabled?: boolean;
    isSaveAndFreezeDisabled?: boolean;
}

interface State {
}

export default class ActionCard extends React.PureComponent<Props, State> {
    constructor(props) {
        super(props);
    }

    render(): React.ReactNode {
        return (
            <React.Fragment>
                <div className={styles['footer-container']}>

                    <Button
                        color={'primary'}
                        outline
                        className="btn me-2"
                        onClick={() => this.props.onCancel()}
                    >
                        Cancel
                    </Button>

                    {
                        !!this.props.onSave && (
                            <Button
                                color={'primary'}
                                className="btn btn-primary me-2"
                                onClick={() => this.props.onSave && this.props.onSave()}
                                disabled={this.props.isSaveDisabled || false}
                            >
                                Save
                            </Button>
                        )
                    }

                    {
                        !!this.props.onSaveAndFreeze && (
                            <Button
                                color={'primary'}
                                className="btn btn-primary"
                                onClick={() => this.props.onSaveAndFreeze && this.props.onSaveAndFreeze()}
                                disabled={this.props.isSaveAndFreezeDisabled || false}
                            >
                                Save & Freeze
                            </Button>
                        )
                    }

                </div>
            </React.Fragment>
        );
    }
}
